var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_236_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H0V44H44V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_236_32)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 21.4845C43.75 33.2007 34.0179 42.7074 21.9981 42.7074C9.97843 42.7074 0.25 33.2007 0.25 21.4845C0.25 9.76843 9.98213 0.261719 21.9981 0.261719C34.0141 0.261719 43.75 9.76849 43.75 21.4845Z",
    fill: "white",
    stroke: "#0E344B",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_236_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 22,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 10.7324H11V32.1958H33V10.7324Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_236_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0012 21.8778C25.1441 21.8778 27.7132 19.3713 27.7132 16.3052C27.7132 13.2389 25.1441 10.7324 22.0012 10.7324C18.8582 10.7324 16.2892 13.2389 16.2892 16.3052C16.2892 19.3713 18.8583 21.8778 22.0012 21.8778ZM31.8039 26.3312C31.6542 25.9661 31.4547 25.6255 31.2303 25.3091C30.0829 23.6543 28.3119 22.5592 26.3165 22.2915C26.067 22.2672 25.7926 22.3158 25.5931 22.4619C24.5455 23.2162 23.2983 23.6055 22.0012 23.6055C20.7041 23.6055 19.457 23.2162 18.4093 22.4619C18.2098 22.3158 17.9354 22.2428 17.686 22.2915C15.6906 22.5592 13.8946 23.6543 12.7722 25.3091C12.5476 25.6255 12.3481 25.9904 12.1985 26.3312C12.1237 26.4771 12.1486 26.6474 12.2235 26.7935C12.423 27.1342 12.6724 27.475 12.8969 27.7669C13.246 28.2293 13.6203 28.643 14.0443 29.0323C14.3934 29.373 14.7925 29.6893 15.1917 30.0057C17.1623 31.4415 19.5319 32.1958 21.9763 32.1958C24.4207 32.1958 26.7903 31.4414 28.7609 30.0057C29.16 29.7137 29.559 29.373 29.9083 29.0323C30.3074 28.643 30.7064 28.2293 31.0557 27.7669C31.3051 27.4506 31.5296 27.1342 31.7291 26.7935C31.8537 26.6474 31.8787 26.4771 31.8039 26.3312Z",
    fill: "#0E344B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.2030435ff228f36be43b9c5bbb4bb71d.svg";
export { ForwardRef as ReactComponent };